<div *ngIf="(transcription ?? []).length > 0" class="text-left" >
   <p-divider align="center" class="w-full">
      <span class="text-500" style="display: flex; align-items: center">
         <img src="/assets/icons/ai_star.svg" alt="Sparkle ai" />
         &nbsp; {{ 'DATA.MODULES.CUSTOMERS.PAGES.ACTIVITIES.LABEL.CALL_INIT' | translate }}
      </span>
   </p-divider>

   <div *ngFor="let event of transcription">
      <!-- CUSTOMER -->
      <div *ngIf="event.speaker === 'customer'" class="grid grid-nogutter">
         <div class="mr-3 mt-1">
            <p-avatar
               [label]="customerName.substring(0, 2).toUpperCase()"
               size="large"
               [style]="{ 'background-color': '#f0fce9', color: '#2c6112' }"
               shape="circle"
            ></p-avatar>
         </div>
         <div class="col mt-3 flex flex-column">
            <div class="text-600 mb-1 text-sm">{{ customerName }}</div>
            <span
               class="text-800 border-green-400 bg-green-50 inline-block font-medium border-1 surface-border p-3 mt-1 mb-1 white-space-normal border-round flex flex-column lg:w-8 xl:w-7"
               style="word-break: break-word"
            >
               {{ event.message }}
            </span>
         </div>
      </div>

      <!-- SYSTEM -->
      <div *ngIf="event.speaker === 'system'" class="flex justify-content-end mt-3">
         <div class="flex flex-column align-items-end mr-3">
            <div class="text-600 mb-1 text-sm">Sistema</div>
            <span
               class="text-800 border-bluegray-200 bg-bluegray-50 inline-block font-medium border-1 surface-border p-3 mt-1 mb-1 white-space-normal border-round flex flex-column lg:w-8 xl:w-7"
               style="word-break: break-word"
            >
               {{ event.message }}
            </span>
         </div>
          <p-avatar
              class="custom-agent-avatar"
              image="../assets/icons/agent.svg"
              size="large"
              shape="circle"
              [style]="{ 'background-color': '#f3f3f3', color: '#5c5c5e' }"
          ></p-avatar>
      </div>
   </div>

   <p-divider align="center" class="w-full">
      <span class="text-500" style="display: flex; align-items: center">
         <img src="/assets/icons/ai_star.svg" alt="Sparkle ai" />
         &nbsp; {{ 'DATA.MODULES.CUSTOMERS.PAGES.ACTIVITIES.LABEL.CALL_FINISH' | translate }}
      </span>
   </p-divider>

    <p-scrollTop target="parent" styleClass="custom-scrolltop" [threshold]="100" icon="pi pi-arrow-up" />

</div>

<div id="no-trans" *ngIf="!transcription.length" class="text-center text-500 p-3">
   {{ 'DATA.MODULES.CUSTOMERS.PAGES.ACTIVITIES.LABEL.NO_TRANSCRIPTION' | translate }}
</div>
